import { useField } from 'formik';

function PriceInput({ name, label, placeholder, disabled, className = '', bottomText, onChange, currency = 'LKR' }) {
  const [field, meta] = useField(name);

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  }

  return (
    <div className={`input price-input ${className} ${meta.touched && meta.error ? 'error' : ''}`}>
      <label htmlFor={name}>{label}</label>

      <div className="input-field">
        <div className="currency">
          <span>{currency}</span>
        </div>

        <input
          {...field}
          type="text"
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          onChange={handleChange}
        />
      </div>

      <div className="meta">
        {meta.touched && meta.error ? <small className="error-msg">{meta.error}</small> : null}
        {bottomText ? <small>{bottomText}</small> : null}
      </div>
    </div>
  );
}

export default PriceInput;
